export function getSupportedLanguageFromString(supportedLanguages, url) {
    const languages = supportedLanguages.filter(e => url.includes(e.toLowerCase()));
    if (languages.length) {
        console.log({languages, supportedLanguages, url})
        return languages[0];
    }

    return "en-gb";
}
